import {connect} from 'react-redux';
import ScheduleEventList from 'shared/ScheduleEventList.jsx';
import {
  handleEventSquadAddClick,
  handleSquadFeesButtonClick,
  handleDateSelection,
  handleTeamOwnedVirtualEventAddClick
} from './actions';
import {
  updateSquadQuantity,
  updateTeamOwnedVirtualEventQuantity
} from './actionTypes';

const mapStateToProps = state => ({
  source: state.registration.scheduler.events,
  selectedDate: state.registration.scheduler.calendar.selectedDate
});

const mapDispatchToProps = dispatch => ({
  onEventSquadFeesClick: (eventPrice, eventAddOnFees) => dispatch(handleSquadFeesButtonClick(eventPrice, eventAddOnFees)),
  onEventSquadQuantityChange: data => dispatch(updateSquadQuantity(data)),
  onEventSquadAddClick: (squadId, quantity) => dispatch(handleEventSquadAddClick(squadId, quantity)),
  onNextDateClick: date => dispatch(handleDateSelection(date)),
  onAddClick: item => dispatch(handleTeamOwnedVirtualEventAddClick(item)),
  onQuantityChange: (eventId, virtualEventId, quantity) => dispatch(updateTeamOwnedVirtualEventQuantity(eventId, virtualEventId, quantity))
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEventList);



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/ScheduleEventListContainer.jsx